import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteShippingMethod = {
  name: "deleteShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingMethodId: zExt.objectId(),
  }),
  output: z.null(),
};
